import React, { useState, useEffect, useReducer, useRef } from "react";
import DataGrid, {
  Column,
  Lookup,
  HeaderFilter,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import {
  CONFIG,
  sizeValues,
  fontValues,
  headerValues,
} from "../common/rps/config";
import ScrollView from "devextreme-react/scroll-view";
import rpsReducer from "../../reducers/rps";
import moment from "moment";
import Button from "devextreme-react/button";
import { alert } from "devextreme/ui/dialog";
import * as action from "../../actions/rps";
import { confirm } from "devextreme/ui/dialog";
import Validator, {
  RequiredRule,
  PatternRule,
} from "devextreme-react/validator";
import NEXUS_CONST from "../../common/constants";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import { postLogForFilter } from "./utils";
import { postUserLog } from "../../actions/common";
import { isEmpty } from "lodash";
import {
  set,
  get,
  setGridUserPrefs,
  setGridWidthPrefs,
  applyUserPref,
  saveUserPref,
} from "../../common/utils";

const initialStates = {
  approvers: [],
  peopleList: [],
  reasonCodes: [],
  rpsRail: [],
  userPrefSps: null,
};
const generalInfoInitialState = {
  currEndDate: new Date(),
  dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
  areaToSolve: "",
  problemToSolve: "",
  approvers: "",
  coach: "",
  teamMembers: [],
};

const Completionplan = ({
  rpsID,
  siteId,
  data,
  activeItem,
  tierId,
  handleSPSSave,
  setisOpen,
  navigationOn,
}) => {
  const [theRpsId, setTheRpsId] = useState(rpsID == null ? 1 : rpsID);
  const [state, dispatch] = useReducer(rpsReducer, initialStates);
  let { approvers, ophFile, reasonCodes, rpsRail } = state;
  const { peopleData, userPrefSps } = state;
  const widgetId = "spsBox7";
  const GRID_COLS = JSON.stringify([
    "causeID",
    "rcaId",
    "solutionId",
    "solution",
    "solutionNameId",
    "expectedImprovement",
    "owner",
    "benefit",
    "difficulty",
    "pickStatus",
  ]);
  const loggedinUser = get("hid");
  const PREF_KEY = "userPref_" + widgetId;
  const [distinctUsers, setDistinctUsers] = useState([]);
  const [generalInfoData, setGeneralInfoData] = useState({
    ...generalInfoInitialState,
  });
  const [enableSave, setEanbleSave] = useState(false);
  const stat = ["Not Started", "In Progress", "Completed"];
  const [gridData, setGridData] = useState([]);
  const dataGridRef = useRef(null);

  useEffect(() => {
    let siteInfo = `&siteId=` + siteId;

    action.fetchUsers(dispatch, "tierId=" + tierId, siteInfo);
    action.getApproverHighestTier(dispatch, siteId);
    action.fetchReasonCodeByFrequency(dispatch, tierId);
    action.fetchPeopleList(dispatch, siteId);
    action.fetchRPSRail(dispatch, theRpsId);
    AsyncCallHandler(
      NEXUS_CONST.FETCH_PS_DATA + theRpsId,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res) {
        setEanbleSave(res?.data?.status === "Complete");
      }
    });
    // Added condition to avoid exception if data not present
    // NEX-1750 Start
    setGeneralInfoData({
      ...generalInfoData,
      areaToSolve:
        data !== undefined && data[activeItem] !== undefined
          ? data[activeItem].title
          : "",
    });
    // NEX-1750 Ends
  }, []);

  useEffect(() => {
    action.fetchUserPref(
      dispatch,
      `=${tierId}&SiteUID=${siteId}&widgetID=${widgetId}`
    );
    return () => {
      action.updateUserPref(
        dispatch,
        saveUserPref({
          widgetId,
          siteId,
          tierId,
          moduleName: "DownTimeReason",
          loggedinUser,
          prefSess: PREF_KEY,
          GRID_COLS,
        })
      );
    };
  }, []);

  useEffect(() => {
    if (userPrefSps) set(PREF_KEY, userPrefSps);
    if (
      dataGridRef &&
      dataGridRef.current &&
      dataGridRef.current.instance !== null &&
      userPrefSps &&
      gridData
    ) {
      applyUserPref(dataGridRef, userPrefSps);
    }
  }, [userPrefSps, gridData]);

  useEffect(() => {
    setGridData(rpsRail);
  }, [rpsRail]);

  useEffect(() => {
    // if(peopleData !== undefined)
    // {
    //  if (peopleData.length > 0) {
    populateDistinctUsersList();
    //  }
    //}
  }, [peopleData]);

  const populateDistinctUsersList = () => {
    let _distinctUsers = [
      ...new Map(peopleData?.map((ele) => [ele["employeeID"], ele])).values(),
    ];
    setDistinctUsers([..._distinctUsers]);
  };

  const onRowInserted = (data) => {
    let {
      rpsid,
      task,
      metric,
      dueDate,
      owner,
      completedon,
      status = [],
    } = data.data;
    let input = {
      Id: 0,
      rpsid: theRpsId,
      Task: task,
      Metric: metric,
      DueDate: moment(dueDate).format(),
      Owner: owner,
      CompletedOn:
        completedon == undefined ? null : moment(completedon).format(),
      Status: status != "" ? status : null,
    };
    //action.saveRPSRAIL(dispatch, input, theRpsId);

    // action.saveRPSRAIL(dispatch, input, selectedId);
  };

  const onRowUpdated = (data) => {
    let {
      rpsid,
      task,
      metric,
      dueDate,
      owner,
      completionPlanId,
      completedOn,
      status = [],
    } = data.data;

    let input = {
      Id: theRpsId,
      rpsid: theRpsId,
      Task: task,
      Metric: metric,
      DueDate: moment(dueDate).format(),
      Owner: owner,
      completionPlanId: completionPlanId,
      CompletedOn:
        completedOn == undefined ? null : moment(completedOn).format(),
      Status: status != "" ? status : null,
    };

    // action.updateRPSRAIL(dispatch, input, theRpsId);
    //}
  };

  const onRowRemoved = (data) => {
    let { rpsid, task, metric, dueDate, owner, completionPlanId, IsArchive } =
      data.data;
    let input = {
      Id: theRpsId,
      rpsid: theRpsId,
      completionPlanId: completionPlanId,
      Owner: owner,
      IsArchive: "1",
    };
    // let confirm_it = confirm("Are you sure you want to delete?", "confirm");
    // confirm_it.then((res) => {
    //   if (res) {
    //     action.updateRPSRAIL(dispatch, input, theRpsId);
    //   } else {
    //     action.fetchRPSRail(dispatch, theRpsId);
    //   }
    // });
  };

  const handlers = {
    onRowInserted: onRowInserted,
    onRowUpdated: onRowUpdated,
    onRowRemoved: onRowRemoved,
  };

  const saveRA = () => {
    dataGridRef.current?.instance?.saveEditData();
    if (rpsRail && rpsRail?.length == 0) {
      alert("Please enter at least one completion plan", "Alert");
      return false;
    } else {
      let data = {
        rpsid: theRpsId,
        completionModel: gridData,
        lastSavedTab: "7",
        section: navigationOn,
        siteId: siteId,
        tierId: tierId,
      };

      AsyncCallHandler(
        NEXUS_CONST.POST_MANAGE_COMPLETIONPLAN,
        NEXUS_CONST.POST,
        data
      ).then((res) => {
        if (res.data) {
          action.fetchRPSRail(dispatch, theRpsId);
          handleSPSSave();
          setisOpen("7");
        }
      });
      // POST_MANAGE_COMPLETIONPLAN
      handleSPSSave();
      setisOpen("7");
    }
    setisOpen("7");
  };

  const cellRenderColor = (cell) => {
    return (
      <div style={{ textAlign: "center", width: "20px", height: "20px" }}>
        <span
          style={{
            background: cell.data.andon,
            textAlign: "center",
            marginLeft: "20px",
          }}
          className="rpsAndonDot"
        ></span>
      </div>
    );
  };

  function handleGridOptionChanged(e) {
    postLogForFilter(
      dataGridRef,
      e,
      siteId,
      tierId,
      "Completion Plan",
      7,
      rpsID,
      navigationOn
    );
  }

  return (
    <>
      <div className="title-section">
        {" "}
        <h2 className="sps_title">
          <span className="sps-print">Box 7 - &nbsp;</span>Completion Plan
        </h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={enableSave}
            width={200}
            onClick={saveRA}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView width="100%" height="420px" className="sps-box-s">
        <div>
          <DataGrid
            ref={dataGridRef}
            dataSource={gridData}
            allowColumnReordering={true}
            showBorders={true}
            {...CONFIG.RPS_EXPERIMENT}
            {...handlers}
            wordWrapEnabled={true}
            width={"100%"}
            onOptionChanged={handleGridOptionChanged}
            onExporting={() =>
              postUserLog({
                event: `Box 7 - Completion Plan Export`,
                data: {
                  action: `Completion Plan exported for PS-${rpsID}`,
                  module: "Digital Tier",
                  section: activeItem,
                  siteUId: siteId,
                  widget: "Structured Problem Solving",
                  tierId,
                },
              })
            }
            onToolbarPreparing={function (e) {
              var dataGrid = e.component;
              var toolbarItems = e.toolbarOptions.items;
              // Adds a new item
              toolbarItems.unshift(
                {
                  location: "before",
                  template: "",
                },
                {
                  location: "after",
                  widget: "dxButton",
                  options: {
                    icon: "refresh",
                    hint: "Refresh",
                    onClick: function () {
                      dataGrid.refresh();
                      postUserLog({
                        event: `Box 7 - Completion Plan Refreshed`,
                        data: {
                          action: `Completion Plan refreshed for PS-${rpsID}`,
                          module: "Digital Tier",
                          section: activeItem,
                          siteUId: siteId,
                          widget: "Structured Problem Solving",
                          tierId,
                        },
                      });
                    },
                  },
                }
              );
            }}
            onContentReady={(e) => setGridUserPrefs(e, widgetId)}
            onColumnsChanging={(e) => setGridWidthPrefs(e, widgetId)}
          >
            <SearchPanel
              visible={true}
              onTextChange={(e) => {
                if (!isEmpty(e)) {
                  postUserLog({
                    event: "Box 7 - Completion Plan Grid Search",
                    data: {
                      action: `${e} searched in completion plan grid PS-${rpsID}`,
                      module: "Digital Tier",
                      section: activeItem,
                      siteUId: siteId,
                      widget: "Structured Problem Solving",
                      tierId: tierId,
                    },
                  });
                }
              }}
            />
            <Column
              dataField="IsArchive"
              caption="IsArchive"
              visible={false}
              allowEditing={false}
              minWidth={20}
            ></Column>
            <Column
              dataField="rpsid"
              caption="PS ID"
              visible={false}
              allowEditing={false}
              minWidth={20}
            ></Column>
            <Column
              dataField="completionPlanId"
              caption="Completion Plan Id"
              visible={false}
              allowEditing={false}
              minWidth={20}
            ></Column>
            <Column
              dataField="task"
              caption="Task"
              visible={true}
              cssClass="WrappedColumn"
              width={200}
              minWidth={20}
            >
              <RequiredRule />
            </Column>
            <Column dataField="metric" caption="Metric" minWidth={20}>
              <Lookup dataSource={data} valueExpr="title" displayExpr="title" />
              <RequiredRule />
            </Column>
            <Column
              dataField="dueDate"
              caption="Due Date"
              dataType="date"
              minWidth={20}
            >
              <RequiredRule />
            </Column>
            <Column dataField="owner" caption="Owner" minWidth={20}>
              <Lookup
                dataSource={distinctUsers}
                valueExpr="employeeID"
                displayExpr="employeeName"
              />
              <RequiredRule />
            </Column>
            <Column
              dataField="completedOn"
              caption="Completed Date"
              dataType="date"
              minWidth={20}
            ></Column>
            <Column dataField="status" caption="Status" minWidth={20}>
              <Lookup dataSource={stat} />
            </Column>
            <Column
              dataField="ColorCode"
              caption="Andon"
              cellRender={cellRenderColor}
              allowEditing={false}
              minWidth={20}
            ></Column>
          </DataGrid>
        </div>
      </ScrollView>
    </>
  );
};
export default Completionplan;
